import { z } from "zod";
import {
  EXPERIMENT_ENTITY_PREFIX,
  isValidPrefixedKsuid,
  PROJECT_ENTITY_PREFIX,
} from "@/utils/ksuidGenerator";
import { parseCatalogEntityPayload } from "@/lib/toolCardSchemas/parseCatalogEntityPayload";

const prefixedKsuid = (prefix: string, label: string) =>
  z.string().refine((id) => isValidPrefixedKsuid(id, prefix), {
    message: `Invalid ${label} public ID`,
  });

export const ApproveExperimentPayloadSchema = z.object({
  experimentPublicId: prefixedKsuid(EXPERIMENT_ENTITY_PREFIX, "experiment"),
  experimentTitle: z.string().min(1).optional(),
  projectPublicId: prefixedKsuid(PROJECT_ENTITY_PREFIX, "project"),
});

export const ApproveExperimentResolveSchema = z.object({});

export type ApproveExperimentPayload = z.infer<typeof ApproveExperimentPayloadSchema>;
export type ApproveExperimentResolve = z.infer<typeof ApproveExperimentResolveSchema>;

export type ApproveExperimentToolResult = {
  toolCallId: string;
};

export type ApproveExperimentArgs = {
  entities?: Array<{
    type?: string;
    experimentPublicId?: string;
    experimentTitle?: string;
    projectPublicId?: string;
    toolInvoke?: { toolCallId?: string };
  }>;
  experimentPublicId?: string;
  experimentTitle?: string;
  projectPublicId?: string;
};

export function parseApproveExperimentPayload(args: unknown, toolCallId?: string) {
  return parseCatalogEntityPayload(
    ApproveExperimentPayloadSchema,
    "approve_experiment",
    args,
    toolCallId,
    (entity) => ({
      experimentPublicId: entity.experimentPublicId,
      experimentTitle: entity.experimentTitle,
      projectPublicId: entity.projectPublicId,
    }),
  );
}
